import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Rooms Preview Section Component
 * Features:
 * - Alternating layout (image left/right)
 * - Responsive design
 * - Feature badges
 * - Modern card design
 */
const RoomsPreview = () => {
  const { t } = useLanguage();

  const rooms = [
    {
      id: 'luxury',
      image: `${process.env.PUBLIC_URL}/inc/images/Royal_rooms_Napels_2.jpg`,
      flipped: false,
    },
    {
      id: 'deluxe',
      image: `${process.env.PUBLIC_URL}/inc/images/Royal_rooms_Napels_3.jpg`,
      flipped: true,
    },
    {
      id: 'comfort',
      image: `${process.env.PUBLIC_URL}/inc/images/Royal_rooms_Napels_4.jpg`,
      flipped: false,
    },
  ];

  const features = [
    'Aria Condizionata',
    'WiFi Ad Alta Velocità',
    'TV a Schermo Piatto',
    'Bagno Privato',
  ];

  return (
    <section id="rooms" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-navy mb-4">
            {t('home.roomsPreviewTitle')}
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            {t('home.roomsPreviewSubtitle')}
          </p>
        </div>

        {/* Rooms Grid */}
        <div className="space-y-12 sm:space-y-16 lg:space-y-20">
          {rooms.map((room) => (
            <div
              key={room.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center ${
                room.flipped ? 'lg:grid-flow-dense' : ''
              }`}
            >
              {/* Image */}
              <div
                className={`${
                  room.flipped ? 'lg:col-start-2' : ''
                } h-[300px] sm:h-[400px] lg:h-[500px] rounded-2xl overflow-hidden shadow-2xl group`}
              >
                <img
                  src={room.image}
                  alt={t(`rooms.${room.id}.name`)}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>

              {/* Content */}
              <div
                className={`${
                  room.flipped ? 'lg:col-start-1 lg:row-start-1' : ''
                } space-y-6`}
              >
                <div>
                  <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-primary-bronze mb-4 pb-3 border-b-4 border-primary-bronze inline-block">
                    {t(`rooms.${room.id}.name`)}
                  </h3>
                  <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-6">
                    {t(`rooms.${room.id}.description`)}
                  </p>
                </div>

                {/* Features */}
                <div className="flex flex-wrap gap-3">
                  {features.map((feature, index) => (
                    <span
                      key={index}
                      className="px-4 py-2 bg-gray-100 text-primary-bronze rounded-full text-sm font-semibold hover:bg-primary-bronze hover:text-white transition-colors duration-300 cursor-default"
                    >
                      ✓ {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoomsPreview;

